export function clearApiCache(apiUrl, accessToken, cache) {

  return fetch(`${apiUrl}/v1/cache/clear/${cache}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })

}